import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import GenetecService from "../../services/GenetecService/GenetecService";

export const getGenetecAccessLevel = createAsyncThunk(
  "genetec/access/level/get",
  async (payload) => {
    const res = await GenetecService.getGenetecAccessLevel(payload);
    return res.data;
  },
);

export const getGenetecCardHolder = createAsyncThunk(
  "genetec/card/holder/get",
  async (payload) => {
    const res = await GenetecService.getGenetecCardHolder(payload);
    return res.data;
  },
);

export const addGenetecAccessLevelAndCardHolderToMSGP = createAsyncThunk(
  "genetec/data/sync/msgp/put",
  async (payload) => {
    const res = await GenetecService.addGenetecAccessLevelAndCardHolderToMSGP(
      payload,
    );
    return res.data;
  },
);

export const getAccessLevelAndIntegrationLists = createAsyncThunk(
  "access_level/integration/get",
  async (payload) => {
    const res = await GenetecService.getAccessLevelAndIntegrationLists(payload);
    return res.data;
  },
);
